
<div [class.loader-hidden]="!show">
    <div class="loader-overlay">
        <div>
            <div class="loader" [ngClass]="{ 'loader_background': opacity == true , '':opacity == false}" *ngIf="show">
                
                    <div class="spinner">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                        <div class="rect6"></div>
                        <div class="rect7"></div>
                        <div class="rect8"></div>
                        <div class="rect9"></div>
                        <div class="rect10"></div>
                        <div class="rect11"></div>
                    </div>
               
            </div>
        </div>
    </div>
</div>